module.exports = __webpack_public_path__ + "img/LV40203154352.58b119fc.png";